import { AxiosResponse } from 'axios';

import client from '../../lib/service/publication.service';
import { PublicationImages } from './publication-images.types';

type Response<T> = { publication_images: T };

const PUBLICATION_IMAGES = (publicationId: string) => {
  return `/v1/publications/${publicationId}/publication_images`;
};

const UPDATE_OR_DELETE_PUBLICATION_IMAGES = (
  publicationId: string,
  assetId: string,
) => {
  return `/v1/publications/${publicationId}/publication_images/${assetId}`;
};

const COVER_PUBLICATION_IMAGE = (publicationId: string) =>
  `/v1/publications/${publicationId}/cover_publication_image`;

export async function getPublicationImages(
  publicationId: string,
): Promise<PublicationImages[]> {
  const response = await client.get<
    null,
    AxiosResponse<Response<PublicationImages[]>>
  >(PUBLICATION_IMAGES(publicationId));
  return response.data.publication_images;
}

export async function getCoverPublicationImage(
  publicationId: string,
): Promise<PublicationImages> {
  const response = await client.get<
    null,
    AxiosResponse<{ publication_image: PublicationImages }>
  >(COVER_PUBLICATION_IMAGE(publicationId));
  return response.data.publication_image;
}

export async function postPublicationImages(
  params,
): Promise<PublicationImages> {
  const { publication_id, ...body } = params;
  const response = await client.post<
    PublicationImages,
    AxiosResponse<Response<PublicationImages>>
  >(PUBLICATION_IMAGES(publication_id), body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data.publication_images;
}

export async function putPublicationImages(params): Promise<PublicationImages> {
  const { publication_id, asset_id, ...body } = params;
  const response = await client.put<
    PublicationImages,
    AxiosResponse<Response<PublicationImages>>
  >(UPDATE_OR_DELETE_PUBLICATION_IMAGES(publication_id, asset_id), body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data.publication_images;
}

export async function deletePublicationImages(
  publicationId: string,
  assetId: string,
): Promise<PublicationImages> {
  const response = await client.delete<
    PublicationImages,
    AxiosResponse<Response<PublicationImages>>
  >(UPDATE_OR_DELETE_PUBLICATION_IMAGES(publicationId, assetId));
  return response.data.publication_images;
}
